const toFieldKey = fieldName => {
  return fieldName != null ? `${fieldName}`.trim() : '';
};

export const normalizeMarketplaceConfig = configAsset => {
  const categories = configAsset?.categories?.categories || [];
  const listingTypes = configAsset?.listingTypes?.listingTypes || [];
  const listingFields = configAsset?.listingFields?.listingFields || [];
  const search = configAsset?.search || {};

  const listingFieldsByKey = listingFields.reduce((acc, field) => {
    const key = toFieldKey(field?.key);
    if (!key) {
      return acc;
    }
    return { ...acc, [key]: field };
  }, {});

  const listingFieldOptions = Object.entries(listingFieldsByKey).reduce((acc, [key, field]) => {
    return { ...acc, [key]: field?.enumOptions || [] };
  }, {});

  const filterOptions = listingFields.filter(field => field?.filterConfig?.indexForSearch === true);

  return {
    categories,
    listingTypes,
    listingFields,
    listingFieldsByKey,
    listingFieldOptions,
    filterOptions,
    search,
  };
};
